import {
  BooleanField as RaBooleanField,
  BooleanFieldProps as RaBooleanFieldProps,
} from 'react-admin';
import { SvgIcon, SvgIconProps } from 'shared/mui/SvgIcon/SvgIcon';

import { DoNotDisturbAltIconStyled, CheckIconStyled } from './BooleanField.styled';

export type BooleanFieldProps = RaBooleanFieldProps;

const NoIcon: typeof SvgIcon = (props: SvgIconProps) => <DoNotDisturbAltIconStyled {...props} />;
NoIcon.muiName = 'NoIcon';

export const YesIcon: typeof SvgIcon = (props: SvgIconProps) => <CheckIconStyled {...props} />;
YesIcon.muiName = 'YesIcon';

export const BooleanField = (props: BooleanFieldProps): JSX.Element => (
  <RaBooleanField {...props} FalseIcon={NoIcon} TrueIcon={YesIcon} />
);
